import {
    LOGIN_REQUEST,
    LOGOUT_REQUEST,
    GET_PERSONAL_INFO_REQUEST,
    FORGOT_PASSWORD_REQUEST,
    RESET_PASSWORD_REQUEST,
    COLLAPSE_FORGOT_PASSWORD_FORM,
    COLLAPSE_RESET_PASSWORD_FORM,
    GET_USER_PAGE_REFRESH_REQUEST
} from "./actionTypes";

const login = userCredentials => ({
    type: LOGIN_REQUEST,
    userCredentials: userCredentials
})

const logout = (sessionExpired = false) => ({
    type: LOGOUT_REQUEST,
    sessionExpired
})

const forgotPassword = email => ({
    type: FORGOT_PASSWORD_REQUEST,
    email: email
})

const resetPassword = userResetPassword => ({
    type: RESET_PASSWORD_REQUEST,
    userResetPassword: userResetPassword
})

const collapseForgotPasswordForm = value => ({
    type: COLLAPSE_FORGOT_PASSWORD_FORM,
    value: value
})

const collapseResetPasswordForm = value => ({
    type: COLLAPSE_RESET_PASSWORD_FORM,
    value: value
})

const getUserPersonalInfo = () => ({
    type: GET_PERSONAL_INFO_REQUEST
})

const getUserPageRefresh= () => ({
    type: GET_USER_PAGE_REFRESH_REQUEST
})

export default {
    login,
    logout,
    forgotPassword,
    resetPassword,
    collapseForgotPasswordForm,
    collapseResetPasswordForm,
    getUserPersonalInfo, 
    getUserPageRefresh
}